import { Link } from "react-router";

const TERMS_URL = "https://www.gramfather.com/terms.html";
const PRIVACY_URL = "https://www.gramfather.com/privacy.html";

/** "<prefix> Terms and Privacy Policy." */
export function LegalLine({ prefix }: { prefix: string }) {
  return (
    <>
      {prefix}{" "}
      <a className="gf-link" href={TERMS_URL} target="_blank" rel="noreferrer">
        Terms
      </a>{" "}
      and{" "}
      <a className="gf-link" href={PRIVACY_URL} target="_blank" rel="noreferrer">
        Privacy Policy
      </a>
      .
    </>
  );
}

/** Footer on every signup screen. */
export function SignInLine({ email }: { email?: string }) {
  return (
    <p className="gfp-auth__aside">
      Already have an account?{" "}
      <Link className="gf-link" to="/login" state={email ? { email } : undefined}>
        Sign in
      </Link>
    </p>
  );
}
